import solvlogo from "@/assets/solve.png";
import shopguardlogo from "@/assets/shopguard.png";
import promeatlogo from "@/assets/promeat-white.png";
import t3logo from "@/assets/t3labs.png";
import { SectionTitle } from "@/components/section-title";

const partners = [
    {
        name: "Solv",
        logo: solvlogo,
        url: "https://solv.tec.br",
    },
    {
        name: "ShopGuard",
        logo: shopguardlogo,
        url: "https://www.shopguard.com.br/",
        logoClass: "max-h-21",
    },
    {
        name: "Promeat",
        logo: promeatlogo,
        url: "https://www.promeat.ai/"
    },
    {
        name: "T3Labs",
        logo: t3logo,
        url: ""
    }

];

export function Clients() {
    return (
        <section className="grid gap-6">
            <SectionTitle eyebrow="Parceiros" title="Nossos Clientes e Parceiros" />
            <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-4">
                {partners.map((partner) => (
                    <a
                        key={partner.name}
                        href={partner.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex h-16 items-center justify-center rounded-xl border border-slate-200 dark:border-white/10 bg-gradient-to-br from-white to-slate-50 dark:from-white/5 dark:to-white/10 backdrop-blur transition-all hover:opacity-80 hover:scale-105 px-4 shadow-sm dark:shadow-none"
                        aria-label={`Parceiro ${partner.name}`}
                    >
                        <img
                            src={partner.logo}
                            alt={partner.name}
                            className={`${partner.logoClass ?? "max-h-10"} max-w-full object-contain dark:brightness-100 brightness-0`}
                        />
                    </a>
                ))}
            </div>
        </section>
    );
}
